import React, { useEffect } from "react";

const NotFoundGhost = () => {
  useEffect(() => { document.title = "404"; }, []);
  return (
    <div
      data-testid="ghost-404"
      className="min-h-screen w-full flex flex-col items-center justify-center bg-[#050505] relative overflow-hidden px-6"
    >
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{ background: "radial-gradient(circle at 50% 50%, #D4AF37 0%, transparent 60%)" }}
      />
      <div className="relative z-10 flex flex-col items-center text-center ax-fade-up">
        <h1 className="font-mono-ax text-7xl sm:text-8xl text-[#F5F5F7] tracking-widest">404</h1>
        <p className="mt-6 text-[#71717A] text-sm tracking-[0.3em] uppercase">
          Página no encontrada
        </p>
        <p className="mt-3 text-[#3f3f46] text-xs max-w-sm">
          El recurso solicitado no existe o no está disponible.
        </p>
      </div>
    </div>
  );
};

export default NotFoundGhost;
